import {all} from 'redux-saga/effects'
import {
    watchLogin,
    watchLogout,
    watchisLoggedIn,
    watchRefreshToken,
    watchgetUserRolesSaga,
} from './login-saga'
import {
    watchEventCategoryDataRequest,
    watchAddEvtCategoryDataRequest,
    watchUpdateEvtCategoryDataRequest,
    watchSetEvtCategoryDataRequest,
    watchDeleteEvtCategoryDataRequest,
    watchEventOccurrenceDataRequest,
    watchAddEvtOccurrenceDataRequest,
    watchUpdateEvtOccurrenceDataRequest,
    watchDeleteEvtOccurrencesDataRequest,
    watchGetEvtOccurrenceSwiperDataRequest,
    watchUpdateEvtOccurrenceSwipersDataRequest,
    watchEventDataRequest,
    watchSwipeTeamsDataRequest,
    watchGetDeptSwipeTeamDataRequest,
    watchAddSwipeTeamDataRequest,
    watchUpdateSwipeTeamDataRequest,
    watchDeleteSwipeTeamDataRequest,
    watchEngagementtypeRequest,
    watchDepartmentsDataRequest,
    watchSetDepartmentsDataRequest,
    watchOccurDataRequest,
    watchLookupDataRequest,
    watchLookupEUIDDataRequest,
    watchSwipeDataRequest,
    watchGetBatchSwipeEmplidsDataRequest,
    watchBatchSwipeValidDataRequest,
    watchBatchSwipeRecordDataRequest,
    watchGetSuperAdminDataRequest,
    watchPutSuperAdminDataRequest,
    watchsetManageRoleDeptDataRequest,
    watchaddManageRolesDeptDataRequest,
    watchupdateManageRolesDeptDataRequest,
    watchdeleteManageRolesDeptDataRequest,
    watchgetDepartmentUsersDataRequest,
    watchaddDepartmentUsersDataRequest,
    watchupdateDepartmentUsersDataRequest,
    watchdeleteDepartmentUsersDataRequest,
    watchgetAllUsersDataRequest,
} from './data-saga'

export default function* rootSaga() {
    yield all([
        watchLogin(),
        watchLogout(),
        watchisLoggedIn(),
        watchRefreshToken(),
        watchgetUserRolesSaga(),
        watchEventCategoryDataRequest(),
        watchAddEvtCategoryDataRequest(),
        watchUpdateEvtCategoryDataRequest(),
        watchSetEvtCategoryDataRequest(),
        watchDeleteEvtCategoryDataRequest(),
        watchEventOccurrenceDataRequest(),
        watchAddEvtOccurrenceDataRequest(),
        watchUpdateEvtOccurrenceDataRequest(),
        watchDeleteEvtOccurrencesDataRequest(),
        watchGetEvtOccurrenceSwiperDataRequest(),
        watchUpdateEvtOccurrenceSwipersDataRequest(),
        watchEventDataRequest(),
        watchSwipeTeamsDataRequest(),
        watchGetDeptSwipeTeamDataRequest(),
        watchAddSwipeTeamDataRequest(),
        watchUpdateSwipeTeamDataRequest(),
        watchDeleteSwipeTeamDataRequest(),
        watchEngagementtypeRequest(),
        watchDepartmentsDataRequest(),
        watchSetDepartmentsDataRequest(),
        watchOccurDataRequest(),
        watchLookupDataRequest(),
        watchLookupEUIDDataRequest(),
        watchSwipeDataRequest(),
        watchGetBatchSwipeEmplidsDataRequest(),
        watchBatchSwipeValidDataRequest(),
        watchBatchSwipeRecordDataRequest(),
        watchGetSuperAdminDataRequest(),
        watchPutSuperAdminDataRequest(),
        watchsetManageRoleDeptDataRequest(),
        watchaddManageRolesDeptDataRequest(),
        watchupdateManageRolesDeptDataRequest(),
        watchdeleteManageRolesDeptDataRequest(),
        watchgetDepartmentUsersDataRequest(),
        watchaddDepartmentUsersDataRequest(),
        watchupdateDepartmentUsersDataRequest(),
        watchdeleteDepartmentUsersDataRequest(),
        watchgetAllUsersDataRequest(),
    ])
}
